export const ROUTE_PATHS = {
  HOME: '/',
  SERVICES: '/services',
  ABOUT: '/about',
  CONTACT: '/contact',
  PRICING: '/pricing',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  CREDIT_REPAIR: '/dashboard/credit-repair',
  TAX_STRATEGY: '/dashboard/tax-strategy',
  BUSINESS_FUNDING: '/dashboard/business-funding',
  GOAL_ROADMAP: '/dashboard/goal-roadmap',
  CREDIT_EDUCATION: '/dashboard/credit-education',
  ADMIN: '/admin',
  DEMO_CREDIT_BUILDER: '/demo/credit-builder',
  DEMO_WEALTH_ACCELERATOR: '/demo/wealth-accelerator',
  DEMO_BUSINESS_EMPIRE: '/demo/business-empire',
  DEMO_MILLIONAIRE: '/demo/millionaire-mentorship',
} as const;

export interface Service {
  id: string;
  title: string;
  description: string;
  icon: string;
  features: string[];
  aiCapabilities: string[];
  image: string;
}

export interface Testimonial {
  id: string;
  name: string;
  role: string;
  company: string;
  content: string;
  rating: number;
  image: string;
}

export interface Stat {
  id: string;
  value: string;
  label: string;
  icon: string;
  description: string;
}

export interface FAQ {
  id: string;
  question: string;
  answer: string;
}
